import React from 'react';
import DeliveryBetweenPostsComponent from '../Component';

export default function DeliveryBetweenPosts() {
  return <DeliveryBetweenPostsComponent />;
}
